class BundleManager extends HTMLElement {
  constructor() {
    super();

    this.storageKey = 'byob_bundle';
    this.state = this.load() || { items: [], maxItems: 5 };

    this.handleAdd = this.handleAdd.bind(this);
    this.handleQtyChange = this.handleQtyChange.bind(this);
    this.addBundleToCart = this.addBundleToCart.bind(this);
  }

  connectedCallback() {
    this.bundleContainer = this.querySelector('.bundle-items');
    this.bundleATC = this.querySelector('#bundle-add-to-cart');

      // READ slots from Liquid blocks
    const slotsFromBlocks = Number(
        this.bundleContainer?.dataset.bundleSlots
    );

    if (slotsFromBlocks) {
        this.state.maxItems = slotsFromBlocks;
    }

    this.render();
    this.syncProductCards();
    this.updateBundleCTA();
    this.updateBundleCount();
    this.updateSavingsVisibility();
    this.updateBundleInfo();
    this.updateBundleSteps();
    this.updateBundleProgress();

    document.addEventListener('click', this.handleAdd);
    document.addEventListener('click', this.handleQtyChange);

    if (this.bundleATC) {
      this.bundleATC.addEventListener('click', this.addBundleToCart);
    }

    document.addEventListener('click', this.handleMobileProductsToggle.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleAdd);
    document.removeEventListener('click', this.handleQtyChange);
    document.removeEventListener('click', this.handleMobileProductsToggle);
  }

  /* ----------------------------
     BUNDLE STATE HELPERS
  -----------------------------*/

  save() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.state));
  }

  load() {
    return JSON.parse(localStorage.getItem(this.storageKey));
  }

  resetBundle() {
    this.state = {
      items: [],
      maxItems: this.state.maxItems
    };

    localStorage.removeItem(this.storageKey);
    this.render();
    this.syncProductCards();
    this.updateBundleCTA();
    this.updateBundleCount();
    this.updateSavingsVisibility();
    this.updateBundleInfo();
    this.updateBundleSteps();
    this.updateBundleProgress();
  }

  /* ----------------------------
     ADD / REMOVE ITEMS
  -----------------------------*/

  handleAdd(e) {
    const btn = e.target.closest('.byob-add');
    if (!btn) return;

    this.addItem({
      productId: Number(btn.dataset.productId),
      variantId: Number(btn.dataset.variantId),
      title: btn.dataset.title,
      price: Number(btn.dataset.price),
      image: btn.dataset.image
    });
  }

addItem(item) {
  if (this.state.items.length >= this.state.maxItems) return;

  const maxQty = this.getMaxQtyPerProduct();

  if (maxQty > 0) {
    const currentQty = this.getProductQty(item.variantId);

    if (currentQty >= maxQty) {
      this.showQtyLimitMessage(item.variantId);
      return;
    }
  }

  this.state.items.push({ ...item });

  this.save();
  this.render();
  this.syncProductCards();
  this.updateBundleCTA();
  this.updateBundleCount();
  this.updateSavingsVisibility();
  this.updateBundleInfo();
  this.updateBundleSteps();
  this.updateBundleProgress();
}

  removeOneItem(variantId) {
    const index = this.state.items.findIndex(
      item => item.variantId === variantId
    );

    if (index === -1) return;

    this.state.items.splice(index, 1);

    this.save();
    this.render();
    this.syncProductCards();
    this.updateBundleCTA();
    this.updateBundleCount();
    this.updateSavingsVisibility();
    this.updateBundleInfo();
    this.updateBundleSteps();
    this.updateBundleProgress();
    this.hideQtyLimitMessage(variantId);
  }

  removeAllOfVariant(variantId) {
    this.state.items = this.state.items.filter(
      item => item.variantId !== variantId
    );

    this.save();
    this.render();
    this.syncProductCards();
  }

  /* ----------------------------
     PRODUCT CARD QTY UI
  -----------------------------*/

  getProductQty(variantId) {
    return this.state.items.filter(
      item => item.variantId === variantId
    ).length;
  }

  syncProductCards() {
    document.querySelectorAll('.byob_product-card-button-wrapper').forEach(wrapper => {
      // Skip sold-out products – their button is already disabled server-side
      if (wrapper.closest('.byob_product-card-wrapper.is-sold-out')) return;

      const addBtn = wrapper.querySelector('.byob-add');
      if (!addBtn) return;

      const variantId = Number(addBtn.dataset.variantId);
      const qty = this.getProductQty(variantId);

      if (qty > 0) {
        wrapper.classList.add('is-active');
        addBtn.textContent = qty;
      } else {
        wrapper.classList.remove('is-active');
        addBtn.innerHTML = `
        <span class="add-to-bundle-text">Add to Bundle</span>
        <span class="bundle-product-atc-plus-button">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 16 16">
            <g id="Group_436166" data-name="Group 436166" transform="translate(-321 -502)">
            <g id="Group_431126" data-name="Group 431126" transform="translate(322.44 503)">
                <line id="Line_54400" data-name="Line 54400" x2="14" transform="translate(-0.44 7)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"></line>
                <line id="Line_54401" data-name="Line 54401" y1="14" transform="translate(6.56)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"></line>
            </g>
            </g>
        </svg>
        </span>
        `;
      }

      /* -----------------------------
         RESTRICTION LOGIC
      ------------------------------*/

      const maxQty = this.getMaxQtyPerProduct();
      const increaseBtn = wrapper.querySelector('.quantity-increase__button_byob');

      if (maxQty > 0 && increaseBtn) {
        if (qty >= maxQty) {
          increaseBtn.classList.add('is-disabled');
        } else {
          increaseBtn.classList.remove('is-disabled');
          this.hideQtyLimitMessage(variantId);
        }
      } else if (increaseBtn) {
        increaseBtn.classList.remove('is-disabled');
        this.hideQtyLimitMessage(variantId);
      }
    });
  }

  handleQtyChange(e) {
    const wrapper = e.target.closest('.byob_product-card-button-wrapper');
    if (!wrapper) return;

    const addBtn = wrapper.querySelector('.byob-add');
    if (!addBtn) return;

    const variantId = Number(addBtn.dataset.variantId);

    // ➕ Increase = add ONE new line item
    if (e.target.closest('.quantity-increase__button_byob')) {
      const item = this.state.items.find(i => i.variantId === variantId);
      if (!item) return;

      this.addItem(item);
    }

    // ➖ Decrease = remove ONE line item
    if (e.target.closest('.quantity-decrease__button_byob')) {
      this.removeOneItem(variantId);
    }
  }

  /* ----------------------------
     BUNDLE UI (RIGHT PANEL)
  -----------------------------*/

  render() {
    if (!this.bundleContainer) return;

    this.bundleContainer.innerHTML = '';

    const totalSlots = this.state.maxItems;

    for (let i = 0; i < totalSlots; i++) {
      const item = this.state.items[i];

      if (item) {
        const el = document.createElement('div');
        el.className = 'bundle-item';
        el.innerHTML = `
          <img src="${item.image}" />
          <div class="bundle-item-info">
            <p class="bundle-item-title">${item.title}</p>
            <div class="bundle-item-price">
              ₹${(item.price / 100).toFixed(2)}
            </div>
          </div>
          <button class="bundle-remove">×</button>
        `;

        el.querySelector('.bundle-remove').addEventListener('click', () => {
          this.removeOneItem(item.variantId);
        });

        this.bundleContainer.appendChild(el);
      } else {
        const emptyEl = document.createElement('div');
        emptyEl.className = 'bundle-item empty';
        emptyEl.innerHTML = `
          <div class="bundle-placeholder">+</div>
          <div class="bundle-empty-text">
            <p class="bundle-empty-title">YOUR SELECTED PRODUCT</p>
            <span class="bundle-empty-sub">
            ${this.getOfferText(i + 1)}
            </span>
          </div>
        `;

        emptyEl.addEventListener('click', () => {
          this.scrollToProducts();
        });

        this.bundleContainer.appendChild(emptyEl);
      }
    }
  }

  getBundlePrice(count) {
    const priceMap = {
      2: 899,
      3: 1249,
      4: 1599
    };

    return priceMap[count] || '';
  }

  scrollToProducts() {
    document
      .querySelector('.byob-products')
      ?.scrollIntoView({ behavior: 'smooth' });
  }



  /* ----------------------------
     ADD BUNDLE TO CART
  -----------------------------*/

  async addBundleToCart() {
    if (!this.state.items.length) return;

    const button = this.bundleATC;
    if (!button) return;

    // ❌ Check if any bundled product is now out of stock
    const hasOOS = this.state.items.some(item => {
      const card = document.querySelector(
        `.byob-add[data-variant-id="${item.variantId}"]`
      )?.closest('.byob_product-card-wrapper');
      return card && card.classList.contains('is-sold-out');
    });

    console.log('hasOOS',hasOOS);

    if (hasOOS) {
      const oosMsg = this.querySelector('.bundle-oos-message');
      if (oosMsg) {
        oosMsg.hidden = false;
        oosMsg.classList.remove('bundle-shake');
        void oosMsg.offsetWidth;
        oosMsg.classList.add('bundle-shake');
        clearTimeout(this._oosTimer);
        this._oosTimer = setTimeout(() => { oosMsg.hidden = true; }, 4000);
      }
      return;
    }

    button.disabled = true;
    button.classList.add('loading');
    button.innerText = 'Adding…';

    let addedSuccessfully = false;

    try {
      // ✅ Group duplicates into quantities for Shopify
      const itemsMap = {};

      this.state.items.forEach(item => {
        itemsMap[item.variantId] = (itemsMap[item.variantId] || 0) + 1;
      });

      const items = Object.entries(itemsMap).map(
        ([variantId, quantity]) => ({
          id: Number(variantId),
          quantity
        })
      );

      const response = await fetch(routes.cart_add_url, {
        ...fetchConfig('javascript'),
        body: JSON.stringify({
          items,
          sections: ['cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) throw new Error('Add to cart failed');

      const parsedState = await response.json();

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && parsedState.sections?.['cart-icon-bubble']) {
        bubble.innerHTML = parsedState.sections['cart-icon-bubble'];
      }

      addedSuccessfully = true;
    } catch (error) {
      console.error('Bundle add failed', error);
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
      button.innerText = 'Add to Cart';

      if (addedSuccessfully) {
        setTimeout(()=>{
            window.openGokwikSideCart();
        },1000)
        this.resetBundle();
      }
    }
  }

  getBundleOffers() {
    if (this.bundleOffers) return this.bundleOffers;

    const el = document.getElementById('bundle-offers-data');
    if (!el) return [];

    try {
        this.bundleOffers = JSON.parse(el.textContent);
        return this.bundleOffers;
    } catch {
        return [];
    }
  }



  getOfferText(slotIndex) {
  const offers = this.getBundleOffers();

  const offer = offers.find(
    o => Number(o.item) === slotIndex
  );

  if (!offer) return '';

  return `Buy ${offer.item} @ ₹${offer.price}`;
}

getActiveBundleOfferPrice() {
  const itemCount = this.state.items.length;
  const offers = this.getBundleOffers(); // already created earlier

  // Find offer matching item count
  const offer = offers.find(
    o => Number(o.item) === itemCount
  );

  return offer ? Number(offer.price) : null;
}

getBundleProductsTotalPrice() {
  return this.state.items.reduce((total, item) => {
    return total + Number(item.price || 0);
  }, 0);
}

updateBundleCTA() {
  if (!this.bundleATC) return;

  const itemCount = this.state.items.length;

  // ❌ Less than 2 items → disabled
  if (itemCount < 2) {
    this.bundleATC.disabled = true;
    this.bundleATC.textContent = 'Add Bundle To Cart';
    return;
  }

  // ✅ 2 or more items
  const offerPrice = this.getActiveBundleOfferPrice();
  const productsTotalPrice  = this.getBundleProductsTotalPrice();
  const rawSavings = (productsTotalPrice / 100) - offerPrice;
  const savings = Math.round(rawSavings);
  const savingsElement = this.querySelector('.bundle-total-savings');
  const savingsElementPrice = savingsElement.querySelector('.price');

    if (offerPrice && productsTotalPrice) {
    this.bundleATC.disabled = false;

    savingsElementPrice.textContent = `₹${savings}`;

    this.bundleATC.innerHTML = `
        <span class="bundle-btn-text">Add Bundle To Cart</span>
        <span class="bundle-offer-price">₹${offerPrice}</span>
        <span class="bundle-products-total-price">
        ₹${(productsTotalPrice / 100).toFixed(0)}
        </span>
    `;
    } else {
    // No matching offer → keep disabled (safe fallback)
    this.bundleATC.disabled = true;
    this.bundleATC.textContent = 'Add Bundle To Cart';
  }
}

updateBundleCount() {
  const currentCountEl = this.querySelector('.bundle-count .current-count');
  if (!currentCountEl) return;

  currentCountEl.textContent = this.state.items.length;
}

updateSavingsVisibility() {
  const savingsEl = this.querySelector('.bundle-total-savings');
  if (!savingsEl) return;

  const itemCount = this.state.items.length;

  // Hide when bundle is empty or not valid
  if (itemCount < 2) {
    savingsEl.classList.add('hidden');
  } else {
    savingsEl.classList.remove('hidden');
  }
}

getNextBundleOffer() {
  const itemCount = this.state.items.length;
  const offers = this.getBundleOffers();

  // Find the next higher offer than current count
  return offers.find(
    o => Number(o.item) > itemCount
  );
}

updateBundleInfo() {
  const infoEl = this.querySelector('.bundle-info');
  if (!infoEl) return;

  const itemCount = this.state.items.length;

  // Hide when bundle is empty or complete
  if (itemCount === 0 || itemCount >= this.state.maxItems) {
    infoEl.hidden = true;
    return;
  }

  const unlockedOffer = this.getUnlockedBundleOffer();
  const nextOffer = this.getNextBundleOffer();

  // If nothing to show, hide
  if (!unlockedOffer && !nextOffer) {
    infoEl.hidden = true;
    return;
  }

  let html = '';

  // ✅ Show unlocked offer first
  if (unlockedOffer) {
    html += `
      You unlocked <strong>₹${unlockedOffer.price}</strong> bundle price!
    `;
  }

  // ✅ Show next offer
  if (nextOffer) {
    const itemsNeeded = Number(nextOffer.item) - itemCount;

    html += `
      Add ${itemsNeeded} more item${itemsNeeded > 1 ? 's' : ''} to get
      <strong>₹${nextOffer.price}</strong> bundle.
    `;
  }

  infoEl.hidden = false;
  infoEl.innerHTML = html;
}

getUnlockedBundleOffer() {
  const itemCount = this.state.items.length;
  const offers = this.getBundleOffers();

  // Get the highest unlocked offer
  const unlockedOffers = offers.filter(
    o => Number(o.item) <= itemCount
  );

  if (!unlockedOffers.length) return null;

  return unlockedOffers[unlockedOffers.length - 1];
}

updateBundleSteps() {
  const steps = this.querySelectorAll('.bundle-step');
  if (!steps.length) return;

  const itemCount = this.state.items.length;

  steps.forEach(step => {
    const stepCount = Number(step.dataset.stepCount);

    if (itemCount >= stepCount) {
      step.classList.add('active');
    } else {
      step.classList.remove('active');
    }
  });
}

updateBundleProgress() {
  const progressBar = this.querySelector('.bundle-progress-bar');
  if (!progressBar) return;

  const itemCount = this.state.items.length;
  const total = this.state.maxItems;

  const percentage = Math.min(
    (itemCount / total) * 100,
    100
  );

  progressBar.style.width = `${percentage}%`;
}

handleMobileProductsToggle(e) {
  const btn = e.target.closest('.mobile-show-products-cta');
  if (!btn) return;

  const bundleItems = this.querySelector('.bundle-items');
  if (!bundleItems) return;

  const isOpen = bundleItems.classList.toggle('is-open');

  btn.textContent = isOpen ? 'Hide Products' : 'Show Products';
}

getMaxQtyPerProduct() {
  if (this._maxQtyPerProduct !== undefined) return this._maxQtyPerProduct;

  this._maxQtyPerProduct = Number(this.dataset.maxQtyPerProduct) || 0;
  return this._maxQtyPerProduct;
}

showQtyLimitMessage(variantId) {
  const wrapper = document
    .querySelector(`.byob-add[data-variant-id="${variantId}"]`)
    ?.closest('.byob_product-card-button-wrapper');

  if (!wrapper) return;

  const messageEl = wrapper.querySelector('.bundle-qty-error-message');
  if (!messageEl) return;

  messageEl.hidden = false;

  // Trigger shake
  wrapper.classList.remove('bundle-shake');
  void wrapper.offsetWidth;
  wrapper.classList.add('bundle-shake');
}

hideQtyLimitMessage(variantId) {
  const wrapper = document
    .querySelector(`.byob-add[data-variant-id="${variantId}"]`)
    ?.closest('.byob_product-card-button-wrapper');

  if (!wrapper) return;

  const messageEl = wrapper.querySelector('.bundle-qty-error-message');
  if (!messageEl) return;

  messageEl.hidden = true;
}
}

customElements.define('bundle-manager', BundleManager);